// Mimics redux-saga's `takeLatest` for thunks: starting a new run makes the checks of earlier runs return false, so
// a slow, outdated response can't overwrite the result of a newer request.
export const createLatestRunGuard = (): () => () => boolean => {
    let latestRun = 0

    return () => {
        latestRun += 1
        const run = latestRun

        return () => run === latestRun
    }
}
